import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";

import Config from "../Config.json";
import { Link, useNavigate } from "react-router-dom";

const TITLE = "DBC | " + Config.SITE_TITLE;
const DESC = "Create a React App from an HTML Website.";
const CANONICAL = Config.SITE_DOMAIN + "/";

const TermsOfUse = () => {
  return (
    <main className="contact-main-content">
      <Helmet>
  <title>Terms Of Use</title>
  <link rel="canonical" href={CANONICAL} />
  <meta name="description" content={DESC} />
  <meta name="theme-color" content={Config.THEME_COLOR} />
</Helmet>

      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact py-3 ps-3">Terms of Use</h1>
        </div>
        <div className="contact-content-container w-75">
          <h2 className="contact-color contact-margin-y">Terms of Use</h2>
          <h5>
            <strong>Last updated:</strong> May 3, 2025
          </h5>
          <p>
            Please read these Terms of Use carefully before using our website.
            By accessing or using the website, you agree to be bound by these
            terms. If you do not agree with any part of these terms, please do
            not use the website.
          </p>
          <h2 className="contact-color contact-margin-y2">
            1. Nature of the Service
          </h2>
          <p>
            Our website (hereinafter: "Website") is provided free of charge and
            is intended to offer information and the option to subscribe to our
            newsletter.
          </p>
          <h2 className="contact-color contact-margin-y2">
            2. Newsletter Subscription
          </h2>
          <p>
            To subscribe to our newsletter, we only ask for your email address.
            We do not collect or process any other personal data. Your email
            address will only be used for sending newsletters and will not be
            shared with third parties.
          </p>
          <p>
            You may unsubscribe from the newsletter at any time by clicking the
            unsubscribe link included in each email.
          </p>

          <h2 className="contact-color contact-margin-y2">
            3. Data Handling and Privacy
          </h2>
          <p>
            For more information on how we handle data, please refer to our{" "}
            <a href="/PrivacyPolicy">Privacy Policy</a>. We take the protection
            of your personal data seriously.
          </p>
          <h2 className="contact-color contact-margin-y2">4. Disclaimer</h2>
          <p>
            The content on the Website is provided for informational purposes
            only. We do not accept liability for any damages resulting from
            inaccuracies or omissions. We reserve the right to modify the
            information on the Website at any time without prior notice.
          </p>
          <h2 className="contact-color contact-margin-y2">5. Copyright</h2>
          <p>
            All texts, images, graphics, and other content on the Website are
            protected by copyright and are the property of the owner.
            Unauthorized copying, distribution, or use of this content is
            prohibited.
          </p>
          <h2 className="contact-color contact-margin-y2">
            6. Changes to the Terms
          </h2>
          <p>
            We reserve the right to change these Terms of Use at any time. Any
            changes will be published on the Website and become effective upon
            posting.
          </p>
          <h2 className="contact-color contact-margin-y2">7. Contact</h2>
          <p>
            If you have any questions about these terms, please contact us at:{" "}
            <a href="mailto:info@aiinsidelife.com">info@AiinsideLife.com</a>
          </p>
        </div>
      </div>
    </main>
  );
};

export default TermsOfUse;
